import { Component } from '@angular/core';

@Component({
  selector: 'app-fn-business-paydone',
  templateUrl: './fn-business-paydone.component.html',
  styleUrls: ['./fn-business-paydone.component.scss'],
})
export class FnBusinessPaydoneComponent {}
